<template>
  <div class="full-width">
      <b-card v-if="displayForm">
        <h2 v-if="!isUpdate">Inserir nova rota <span class="search-related-news">{{form.routeName}}</span></h2>
        <h2 v-if="isUpdate">Alteração da rota <span class="search-related-news">{{form.routeName}}</span></h2>
        <b-col md="12"></b-col>
        <b-col md="6">
          <div class="form-label-group">
            <label for="country-list">País</label>
            <b-form-group label="País" label-for="country-list">
              <v-select
                id="country-list"
                v-model="form.country"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :options="countries"
              >
                <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
              </v-select>
            </b-form-group>
          </div>
        </b-col>
        <b-col md="6">
          <div class="form-label-group">
            <b-form-input id="routeName" placeholder="Nome da Rota" v-model="form.routeName" />
            <label for="routeName">Nome da Rota</label>
          </div>
        </b-col>
        <b-button
          variant="primary"
          class="mr-1"
          @click="onSubmit"
        >
          {{ isUpdate ? 'Atualizar' : 'Adicionar'}}
        </b-button>
      </b-card>
    <hr v-if="displayForm">
    <b-row>
      <b-col md="6">
        <b-button
          size="sm"
          @click="newData"
          class="btn-sm btn-nav-link btn-nav-link-primary"
        >
          <feather-icon icon="PlusIcon" class="mr-50" />
          <span class="align-middle">Novo</span>
        </b-button>
      </b-col>
      <b-col md="12" class="mt-1">
        <b-list-group v-if="platformWdmaRoute">
          <b-list-group-item v-for="(item, index) in platformWdmaRoute" :key="index" class="list-item-related-news" @click="openData(item)">
            <feather-icon icon="CircleIcon" class="mr-50" style="margin-bottom: 3px" />  <b>{{item.country.name}} ({{item.country.code}})</b> | {{ item.routeName }}
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BCard,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";
import vSelect from "vue-select";
import messagesNotifyHelper from '@/helpers/messages-notify-helper';

export default {
  props: {
    platformWdmaRoute: {
      required: true,
      type: Array,
    },
    countries: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      displayForm: false,
      isUpdate: false,
      form: {
        routeName: "",
        country: ""
      },
    };
  },
  methods: {
    openData(item) {
      this.form.routeName = item.routeName;
      this.form.country = item.country;
      this.displayForm = true;
      this.isUpdate = true;
    },
    newData() {
      this.displayForm = true;
      this.isUpdate = false;
      this.clearForm();
    },
    clearForm() {
      this.form.routeName = '';
      this.form.country = '';
      this.isUpdate = false;
    },
    onSubmit() {
      if (!this.form.routeName || !this.form.country) {
        messagesNotifyHelper.warningNotify('Atenção', `Nome da rota e País obrigatório`);
      }
      if (this.isUpdate) {
        this.$emit('submit-route', JSON.parse(JSON.stringify(this.form)));
        this.clearForm();
        this.displayForm = false;
      } else {
        if (this.platformWdmaRoute.findIndex(item => item.country.id == this.form.country.id) < 0) {
          this.$emit('submit-route', JSON.parse(JSON.stringify(this.form)));
          this.clearForm();
          this.displayForm = false;
        } else {
          messagesNotifyHelper.errorNotify('Erro', `País já cadastrado para a rota ${this.form.country.name}`);
        }
      }
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BCard,
    vSelect,
    BListGroup,
    BListGroupItem,
  },
};
</script>

<style lang="scss">
</style>